/* Kickdopa Section Transitions Plan B (2026-04-26) */
/* Fallback bootstrap for kd-popup — only fires if the snippet didn't render
   (e.g. pages where Liquid template cache is stale). When the snippet IS
   rendering, it already loads kd-popup.css/.js with proper ?v= versioning,
   so we skip to avoid serving stale no-version cached copies. */
(function bootstrapKDPopup(){
  /* Master switch: owner permanently disabled Mystery Discount on 2026-08-10. */
  var KD_POPUP_MASTER_ENABLED = false;
  if (!KD_POPUP_MASTER_ENABLED) return;
  if (window.__kdPopupBoot) return;
  window.__kdPopupBoot = true;
  if (document.getElementById('kd-popup')) return;
  if (document.querySelector('link[href*="kd-popup.css"]')) return;
  if (document.querySelector('script[src*="kd-popup.js"]')) return;
  var base = '/cdn/shop/t/29/assets/';
  var bust = '?v=' + Date.now();
  var l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = base + 'kd-popup.css' + bust;
  document.head.appendChild(l);
  var s = document.createElement('script');
  s.src = base + 'kd-popup.js' + bust;
  s.defer = true;
  document.head.appendChild(s);
})();

(function () {
  'use strict';
  var html = document.documentElement;
  html.classList.add('kd-fx-active');
  var supportsScrollTL = window.CSS && CSS.supports('animation-timeline', 'view()');

  function initFallback() {
    if (supportsScrollTL) return;
    var skipPattern = /(annoucement|header|footer|cart|drawer|popup|modal|sticky)/i;
    var sections = Array.from(document.querySelectorAll('[id^="shopify-section-"]'))
      .filter(function (s) { return !skipPattern.test(s.id); });
    if (sections.length > 0) sections[0].classList.add('kd-fx-revealed');
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('kd-fx-revealed'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('kd-fx-revealed');
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    sections.forEach(function (s, i) { if (i > 0) obs.observe(s); });
  }


  // Why Choose 入场 (用 IO, 不依赖 view() timeline)
  function initWhyChoose() {
    var sec = document.querySelector('[id*="ss_feature_13"]');
    if (!sec) return;
    if (!('IntersectionObserver' in window)) {
      sec.classList.add('kd-wc-in');
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('kd-wc-in');
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.18 });
    obs.observe(sec);
  }


  // Who Can Benefit 入场 (IO 方案)
  function initWhoBenefit() {
    var sec = document.querySelector('[id*="ss_product_ingredients_5"]');
    if (!sec) return;
    if (!('IntersectionObserver' in window)) {
      sec.classList.add('kd-wb-in');
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('kd-wb-in');
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    obs.observe(sec);
  }


  // KD Flavor Lineup: reveal + active state toggle
  function initLineup() {
    var sec = document.querySelector('.kd-lineup');
    if (!sec) return;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (e) {
        e.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('kd-lineup-in'); obs.unobserve(en.target); } });
      }, { threshold: 0.18 });
      obs.observe(sec);
    } else { sec.classList.add('kd-lineup-in'); }
  }

  function init() {
    try { initWhyChoose(); } catch (e) {}
    try { initLineup(); } catch (e) {}
    try { initWhoBenefit(); } catch (e) {}
    try { initFallback(); } catch (e) { console.warn('[kd-fx-b]', e); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
